import { render, staticRenderFns } from "./consult.vue?vue&type=template&id=499ebfdc&scoped=true&"
import script from "./consult.vue?vue&type=script&lang=js&"
export * from "./consult.vue?vue&type=script&lang=js&"
import style0 from "./consult.vue?vue&type=style&index=0&id=499ebfdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ebfdc",
  null
  
)

component.options.__file = "consult.vue"
export default component.exports